import { Css } from "@homebound/beam";
import { useParams } from "react-router";
import { BidContractHeader } from "src/components/bid-contracts/BidContractHeader";
import { DevelopmentContractTabs } from "src/routes/developments/components/DevelopmentContractTabs";
import {
  BidContractRevisionFragment,
  useBidContractRevisionQuery,
} from "src/routes/developments/procurement/DevelopmentContractPage.generated";
import { DevelopmentContractParams } from "src/routes/routesDef";
import { queryResult } from "src/utils";

export function DevelopmentContractPage() {
  const { bidContractRevisionId } = useParams<DevelopmentContractParams>();
  const query = useBidContractRevisionQuery({ variables: { bidContractRevisionId } });
  return queryResult(query, {
    data: ({ bidContractRevision }) => {
      return <DevelopmentContractView bidContractRevision={bidContractRevision} />;
    },
  });
}

type DevelopmentContractProp = {
  bidContractRevision: BidContractRevisionFragment;
};

function DevelopmentContractView({ bidContractRevision }: DevelopmentContractProp) {
  return (
    <>
      <BidContractHeader selectedRevision={bidContractRevision} />
      <div css={Css.mt3.$}>
        <DevelopmentContractTabs selectedRevision={bidContractRevision} />
      </div>
    </>
  );
}
